import styled, { css } from 'styled-components';

import card from 'styles/components/card';
import { COLOR_GRAY_60, COLOR_GRAY_90 } from 'styles/variables/colors';

export const Card = styled.div`
  ${card};
  margin: 0 0 20px 0;
  padding: 12px 20px;
`;

export const Title = styled.h3`
  font-size: 1.5rem;
  font-weight: 800;
  margin: 0 0 10px 0;
`;

export const BillingInterval = styled.p`
  font-size: 0.875rem;
  margin: 0 0 43px 0;
  color: ${COLOR_GRAY_60};
`;

export const AmountContainer = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
`;

export const AmountGrid = styled.div`
  display: inline-flex;
  flex-direction: column;
  align-items: center;
`;

export const AmountIcon = styled.div`
  cursor: pointer;
  text-align: center;
`;

export const AmountContent = styled.div`
  text-align: center;
`;

export const AmountLabel = styled.p`
  margin: 0 0 10px 0;
  font-size: 0.875rem;
  font-weight: bold;
  align-self: flex-start;

  ${(props) =>
    props.noMargin &&
    css`
      margin: 0;
    `}
`;

export const AmountValue = styled.p`
  margin: 0;
  font-size: 1rem;
`;

export const ChangeButtonContainer = styled.div`
  width: 240px;
  display: inline-block;
  margin-right: 35px;
`;

export const CancelButton = styled.button`
  border: 0;
  background: transparent;
  font-weight: bold;
  padding: 0;

  &::after {
    content: '';
    display: block;
    background: ${COLOR_GRAY_90};
    height: 1px;
    width: 100%;
    margin-top: 2px;
  }
`;
